import { createContext } from "react";
import { ModalsType } from "../modal-context/ModalContext";
import { LatestTradeType, TokenType } from "types/token.type";
import { userType } from "types/user.type";

export interface AppContextType {
  user: userType;
  setUser: (user: userType) => void;

  latestTrade: LatestTradeType | null;
  setLatestTrade: (latestTrade: LatestTradeType | null) => void;

  tokens: TokenType[];
  setTokens: (tokens: TokenType[]) => void;

  showAnimations: boolean | null;
  setShowAnimations: (showAnimations: boolean) => void;

  modalStatus: boolean;
  activeModal: ModalsType;
  setActiveModal: (modal: ModalsType) => void;
  setModalStatus: (status: boolean) => void;

  slippage: string | null;
  setSlippage: (slippage: string) => void;

  selectWalletModalState: boolean;
  setSelectWalletModalState: (selectWalletModalState: boolean) => void;

  pepeTokenPrice: number;
  setPepeTokenPrice: (pepeTokenPrice: number) => void;
  pepePriceLoading: boolean;
  watchlistTokens: string[];
  setWatchlistTokens: (tokens: string[]) => void;
}

export const AppContext = createContext<AppContextType>({} as AppContextType);
